import { Injectable } from '@angular/core';
// import { Config } from '../_class/config';
import { Observable, of, Subject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ApiError } from '../_class/req-erros';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  public actionSubject = new Subject<any>();
  actions = this.actionSubject.asObservable();
  baseUrl = environment.apiUrl;
  error = new ApiError(this.actionSubject);
  console1 = console;
  constructor(
    private http: HttpClient,
    private toastr: ToastrService
  ) {
  }

  public post(endpoint: string, params: any, handleErrors?: boolean): Observable<any> {
    const t0 = performance.now();
    const body = JSON.stringify(params);
    console.info(`⬆ POST: ${this.baseUrl}/${endpoint}`);
    return this.http.post(`${this.baseUrl}/${endpoint}`, body, this.post_headers())
      // .pipe(map((res: any) => {
      //   if (res.status) {
      //     const { data } = res;
      //     const { access_token } = data;
      //     if (access_token) { localStorage.setItem('aios', access_token); }
      //   } else if ((!res.status) && (res.message)) {
      //     this.toastr.error(res.message, 'Error');
      //   }
      //   const t1 = performance.now();
      //   console.info(`${endpoint} ${(t1 - t0)} milliseconds.`);
      //   return res;
      // }))
      .pipe(
        // catchError((error, caught) => {
        //   this.toastr.error(this.error.http(error).message);
        //   return of(this.error.http(error));
        // }) as any
      );
  }
  public upload (endpoint:string,formData:any): Observable<any> { 
    return this.http.post(`${this.baseUrl}/${endpoint}`, formData, this.image_headers())
  }
 

  public download(endpoint: string, params: any, handleErrors?: boolean): Observable<any> {
    return this.http.get<Blob>(`https://c3102d0d.ngrok.io/csv`, {}).pipe(
      catchError((error, caught) => {
        this.error.http(error);
        return of(error);
      }) as any);
  }
  public delete(endpoint: string, params: any): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${endpoint}`, { headers: this.get_headers(), params },)
      .pipe(map((res: any) => {
        if (res.status) {
          // const { data } = res;
          // const { access_token_key } = data;
          // if (access_token_key) { localStorage.setItem('currUser', access_token_key); }
        }
        return (res);
      }))

  }
  public deleteWithNoError(endpoint: string, params: any): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${endpoint}`, { headers: this.get_headers(), params },)
      .pipe(map((res: any) => {
        if (res.status) {
          const { data } = res;
          const { access_token_key } = data;
          if (access_token_key) { localStorage.setItem('currUser', access_token_key); }
        }
        return (res);
      }))
      .pipe(
        catchError((error, caught) => {
          return of(error);
        }) as any);
  }
  public get(endpoint: string, params: any, handleErrors?: boolean): Observable<any> {
    console.info(`⬆ POST: ${this.baseUrl}/${endpoint}`);
    return this.http.get(`${this.baseUrl}/${endpoint}`, { headers: this.get_headers(), params })
      .pipe(map((res: any) => {
        if ((!res.status) && (res.message)) {
          this.toastr.error(res.message);
        }
        return (res);
      }));
    // .pipe(
    //   catchError((error, caught) => {
    //     this.error.http(error);
    //     return of(error);
    //   }) as any);
  }
  refreshToken(): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/refresh`, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('aios_refresh')}`,
      })
    }).pipe(switchMap((res: any) => {
      if (res.status && res.response) {
        localStorage.setItem('aios', res.data.access_token);
        return of(res);
      }
      return throwError(res);
    })

    );
  }

  public external_get(domain: string, endpoint: string, params: any, handleErrors?: boolean) {
    return this.http.get(`${domain}/${endpoint}`, { headers: this.external_get_headers(), params })
      .pipe(map((res: any) => {
        if ((!res.status) && (res.message)) {
          this.toastr.error(res.message);
        }
        return (res);
      }))
      .pipe(
        catchError((error, caught) => {
          this.error.http(error);
          return of(error);
        }) as any);
  }

  public external_post(domain: string, endpoint: string, params: any): Observable<any> {
    const body = params;
    return this.http.post(`${domain}/${endpoint}`, body, this.external_post_headers())
      .pipe(map((res: any) => {
        if (res.status) {
          const { data } = res;
        }
        return (res);
      }))
      .pipe(
        catchError((error, caught) => {
          this.error.http(error);
          return of(error);
        }) as any);
  }
  public mwb_post(domain: string, endpoint: string, params: any): Observable<any> {
    const body = JSON.stringify(params);
    return this.http.post(`${domain}/${endpoint}`, body, this.mwb_post_headers())
      .pipe(map((res: any) => {
        if (res.status) {
          const { data } = res;
          const { access_token_key } = data;
          if (access_token_key) { localStorage.setItem('currUser', access_token_key); }
        }
        return (res);
      }))
      .pipe(
        catchError((error, caught) => {
          this.error.http(error);
          return of(error);
        }) as any);
  }

  public imagePost(endpoint: string, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('profile', file, file.name);
    return this.http.post(`${this.baseUrl}/${endpoint}`, formData, this.image_headers())
      .pipe(
        // map((res: any) => {
        //   if (res.status) {
        //     const { data } = res;
        //     const { access_token_key } = data;
        //     if (access_token_key) {
        //       localStorage.setItem('currUser', access_token_key);
        //     }
        //   }
        //   return (res);
        // })
      );
  }
  private get_headers() {
    const headers = new HttpHeaders({
      // 'Origin': 'http://2919af99a429.ngrok.io',
    });
    return headers;
  }
  private external_get_headers(): any {
    const headers = new HttpHeaders({
      origin: 'external',
    });
    return headers;
  }
  private post_headers() {
    const httpOptions = {
      headers: new HttpHeaders({
        // origin: 'makewebbetter',
        "Content-Type": "application/json"
      })
    };
    return httpOptions;
  }
  private formData_post_headers() {
    const httpOptions = {
      headers: new HttpHeaders({
      // origin: 'martech-upload',
      "Content-Type":"",
      }),
      reportProgress: true,
    };
    // httpOptions.headers.delete("content-type","application/json");
    // httpOptions.headers.set("Content-Type","");
    return httpOptions;
  }
  private post_download_headers() {
    const httpOptions = {
      headers: new HttpHeaders({
        origin: 'download',
      })
    };
    return httpOptions;
  }
  private mwb_post_headers() {
    const httpOptions = {
      headers: new HttpHeaders({
        origin: 'makewebbetter',

      })
    };
    return httpOptions;
  }
  private external_post_headers(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        origin: 'external',

      })
    };
    return httpOptions;
  }
  private image_headers(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        "origin": "botmywork-upload",
      }),
      reportProgress: true
    };
    return httpOptions;
  }
  getIP(): Observable<any> {
    return this.http.get('https://ipinfo.io').pipe(
      catchError((error, caught) => {
        this.error.http(error);
        return of(error);
      }) as any);
  }
  sanitize(res: any) {
    const { response, status, data, message } = res;
    if (response && status) { return true; }
    else {
      console.error(message);
      return false;
    }
  }
  // utilty functions

  public get console(): Console {
    if (!environment.production) {
      return console;
    }
    return (new LOG() as any);
  }
  logout(): Observable<any> {
    return this.delete(`auth/logout`, {});
  }

}



class LOG {
  public warn(message?: any, ...optionalParams: any[]): void {
    console.warn(message);
    optionalParams.forEach((param: any) => {
      console.warn(param);
    });
  }
  public log(message?: any, ...optionalParams: any[]): void {
    console.warn(message);
    optionalParams.forEach((param: any) => {
      // console.log(param);
    });
  }
  public info(message?: any, ...optionalParams: any[]): void {
    console.warn(message);
    optionalParams.forEach((param: any) => {
      console.info(param);
    });
  }
  public clear(): void {
    console.clear();
  }
}
